/**
 * returns in the formats:
 *     "{n} days left"
 *     "{n} hours {n} min left"
 *     "{n} minutes {n} sec left"
 *     "{n} sec left"
 */
export const useTruncatedLongCountdownFormat = (
  timeLeft: Ref<Countdown | "">,
) => {
  const { t } = useI18n();

  return computed(() => {
    if (!timeLeft.value) return timeLeft.value;

    const { days, minutes, hours, seconds } = timeLeft.value;

    const daysText = t("countdownTimer.daysText", days);
    const hoursText = t("countdownTimer.hoursText", hours);
    const minutesText = t("countdownTimer.minutesText", minutes);
    const secondsText = t("countdownTimer.secondsText", seconds);

    if (days) {
      return t("countdownTimer.daysLeft", { daysText }, { plural: days });
    }

    if (hours) {
      return t(
        "countdownTimer.hoursLeft",
        { hoursText, minutesText },
        { plural: hours },
      );
    }

    if (minutes) {
      return t(
        "countdownTimer.minutesLeft",
        { minutesText, secondsText },
        { plural: minutes },
      );
    }

    if (seconds) {
      return t(
        "countdownTimer.secondsLeft",
        { secondsText },
        { plural: seconds },
      );
    }

    return undefined;
  });
};
